import { IPrize } from '@base/common/Wheel/interface'

export type IWheelConfigData = {
    activityGid: string;
    canDraw: boolean;
    canObtainCoupon: boolean;
    code: string;
    drawResultCoupon: IDrawResultCoupon;
    endTime: number;
    lastChance: boolean;
    rewards: IPrize[];
    startTime: number;
    couponIcon: IIcon;
    spinIcon: IIcon;
};

export type IIcon = {
    link: string;
    width: string | number;
    height: string | number;
}

export type IDrawResultCoupon = {
    appTag: string;
    couponCode: string;
    couponEndTime: number;
    couponStartTime: number;
    discount: string;
    type: ResultType;
    uniqueId: string;
    productScope: string;
}

export enum ResultType {
    ONE_TIME_AGAIN = "ONE_TIME_AGAIN",
    COUPON = "COUPON",
    NO_REWARD = "NO_REWARD",
}

export type IDrawApi = {
    uniqueIds: (string | number)[];
}
